import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBJumbotron,MDBInputGroup } from 'mdbreact';
 
import { Form, Input, Button, Checkbox,Radio,Select,message,Result } from 'antd';
import Login from './Login';
import Axios from 'axios'
import { URL,api } from '../api';
import Swal from 'sweetalert2'
import ban from '../img/4.png'

function onBlur() {
  console.log('blur');
}

function onFocus() {
  console.log('focus');
}

function onSearch(val) {
  console.log('search:', val);
}

const { Option } = Select;

export default class Register extends Component {
    
    //    state = {
    //       Username: "",
    //       Password: "",
    //       loading: true,
    //       login_error: true,
    //       login_error2: true,
    //       login_error3: true,
    //     }
  
        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                getprefix:[],
                studentmath:false,//โชว์ตรวจสอบสิทธิ์
                studentmathstatus:false,//ตรวจสอบสิทธิ์ 
                OLDID:'',//รหัสนักศึกษาสำหรับตรวจสอบสิทธิ์

                loading: false,
                iconLoading: false,


                universityaddress:[],//มหาวิทยาลัยทั้งหมด
                registertype:[],
                registertypeout:[],
                showadduniversityother:'',


                province : '', //idจังหวัด
                provincename : '', //ชื่อจังหวัด
                amper : '', //idอำเภอ
                ampername : '', //ชื่ออำเภอ
                district : '', //idตำบล
                districtname : '', //ชื่อตำบล
                zipcode : '', //รหัสไป

                //ข้อมูลตัวเลือกส่วนตัว
                PROVINCE :[],
                AMPHUR :[],
                DISTRICT:[],

                //ข้อมูลตัวเลือกอาชีพ
                AMPHURPT:[],
                DISTRICT:[],



                register_typemamberinout:'', //ภายในภายนอก
                register_typemamber :'', //ประเภทผู้ลงทะเบียน
                register_email : '', //email
                register_pass : '', //รหัสผ่าน
                register_pass2: '', //ยืนยันรหัสผ่าน
                register_oldpass: '', //รหัสผ่าน
                register_nameth: '', //ชื่อ
                register_lnameth: '', //นามสกุล
                register_pname: '', //คำนำหน้า
                register_nameen: '', //ชื่อภาษาอังกฤษ
                register_lnameen: '', //นามสกุลอังกฤษ
                register_sex: '', //เพศ
                register_university:'',
                register_nameuniversity:'',
                register_faculty:'',//คณะ
                showfaculty:false, //โชว์สำหรับนักศึกษาคณิต และอาจารย์คณิต
                register_program:'',//สาขาโปรแกรม
                register_numhome: '', //บ้านเลขที่
                register_moo: '', //หมู่
                register_street: '', //ถนน
                register_soi: '', //ซอย
                register_private: '', //จังหวัด
                register_ditric:'',//อำเภอ
                register_subdritic:'',//ตำบล
                register_zipcode:'',//รหัสไปรษณีย์
                register_phone:'', //เบอร์โทร
                register_date:'', //วันที่ลงทะเบียน
                register_activate:'1', // อนุมัติ
                register_status:'1', //สถานะผู้ลง

                register_typepay:'1',
                register_taxnumber:'',
                register_taxadress:'',
                register_taxDISTRICT:'',
                register_taxAMPHUR:'',
                register_taxPROVINCE:'',
                register_taxCODE:'',


                opensystem : true,
            };
            this.handleChange = this.handleChange.bind(this);
            this.handleChange2 = this.handleChange2.bind(this);
          
            this.toggle = this.toggle.bind(this);

            this.handleprovince = this.handleprovince.bind(this)
            this.handleamphur = this.handleamphur.bind(this)
            this.handledistrict = this.handledistrict.bind(this)
            this.handleChangetgender = this.handleChangetgender.bind(this)
            this.handleChangetype = this.handleChangetype.bind(this)
            this.handleChangetypeinout = this.handleChangetypeinout.bind(this)
            this.handleChangetypepay = this.handleChangetypepay.bind(this)
            this.handleChangeuniversity = this.handleChangeuniversity.bind(this)
            this.handleSubmit = this.handleSubmit.bind(this)
            this.getprefix = this.getprefix.bind(this)
            this.handleChangeprefix = this.handleChangeprefix.bind(this)
            this.getcheck = this.getcheck.bind(this)
            this.enterLoading = this.enterLoading.bind(this)
            this.enterIconLoading = this.enterIconLoading.bind(this)
          }


          enterLoading = () => {
            this.setState({ loading: true });
          };
        
          enterIconLoading = () => {
            this.setState({ iconLoading: true });
          };

          // handleSubmitd() {

          //    const form = this.state.getprefix;
          //     api.post("registercon/Addprefix",{
          //       check: form
          //     })
        
          //         .then(res => {
          //               if (res.status === 200) {
                         
          //                         Swal.fire({
          //                               title: 'นำเข้าข้อมูลสำเร็จ',
          //                               icon: 'success',
          //                             // showCancelButton: true,
          //                               confirmButtonText: 'ตกลง',
          //                             // cancelButtonText: 'No, keep it'
          //                             }).then((result) => {
                                      
          //                             })
                              
          //               }
          //         }) 
          // }


          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }

          getprefix() {
            setTimeout(() => {
                   
              api.get('registercon/selectprefix')
               .then(res => {
                 console.log(res);
               //  this.setState({ bankname: res.data, loading: false })
                
 
                 const selectd = res.data.map((i) => ({
                  value: i.PREFIX_NAME_ID,
                  label: i.FULLNAME,
                }));
                this.setState({ getprefix: selectd})

               }) 
             }, 0);
         }

         getcheck() {
          setTimeout(() => {
            const OLDIDS = this.state.OLDID;
            const OLDIDS2 = this.state.OLDID.substring(0, 7);
            console.log(OLDIDS);
            api.get('registercon/selectstudentmath/'+OLDIDS+'/'+OLDIDS2)
             .then(res => {
               console.log(res);
               if (res.data.length >0) {
                this.setState({studentmathstatus: true});  
                
                let text = res.data[0].NAME;
                const myArray = text.split("  ");
                console.log(myArray[0])
                console.log(myArray[1])
                this.setState({register_nameth: myArray[0]});  
                this.setState({register_lnameth: myArray[1]}); 

                let texten = res.data[0].E_NAME;
                const myArrayen = texten.split("  ");
                console.log(myArrayen[0])
                console.log(myArrayen[1])
                this.setState({register_nameen: myArrayen[0]});  
                this.setState({register_lnameen: myArrayen[1]}); 

               }else{
                      Swal.fire({
                        title: 'ตรวจสอบสิทธิ์ไม่ผ่าน กรุณาตรวจสอบรหัสนักศึกษา',
                        text: "Failed to check permissions",
                        icon: 'warning',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง'
                      }).then((result) => {
                        if (result.isConfirmed) {
                      
                        
                        }
                      })
               }
             
             }) 
           }, 0);
         }
        


        
          handleChange(event) {     this.setState({[event.target.name]: event.target.value});   } 
          handleChangeprefix(event) {     this.setState({register_pname: event});   } 
          handleChangetype(event) {   
                  if (event.target.value === '1') {
                      this.setState({register_typemamber: event.target.value}); 
                      this.setState({studentmath: true});  

                  } else {
                      this.setState({register_typemamber: event.target.value}); 
                      this.setState({studentmath: false}); 
                  }

                  if (event.target.value === '1' || event.target.value === '2' ) {
                    this.setState({register_program: 'สาขาวิชาคณิตศาสตร์'}); 
                    this.setState({showfaculty: true});  

                  } else {
                    
                  }

                
             }
          handleChangetypeinout(event) {   
             this.setState({register_typemamber: ''});
             this.setState({register_typemamberinout: event.target.value});
             this.setState({studentmath: false});
                //console.log(event.target.value)
             if (event.target.value === '1') {

                    const result =  this.state.universityaddress.filter((word) => word.id_university	 === event.target.value);
                    console.log(result[0].road_university)
                   
                    this.setState({register_university: '1'}); 
                    this.setState({register_nameuniversity: result[0].name_university}); 
                    this.setState({register_numhome: result[0].homenum_university	}); 
                    this.setState({register_moo: result[0].moo_university}); 
                    this.setState({register_street: result[0].road_university}); 
                    this.setState({register_soi: result[0].alley_university}); 
                    this.setState({register_private: result[0].province_university}); 
                    this.setState({register_ditric: result[0].district_university}); 
                    this.setState({register_subdritic: result[0].subdistrict_university}); 
                    this.setState({register_zipcode: result[0].zipcode_university}); 
                    this.setState({register_taxnumber: result[0].TaxID_university}); 
                  //ภาษี
                    this.setState(  {register_taxadress: result[0].homenum_university+' หมู่ '+result[0].moo_university+' ถนน '+result[0].road_university+' ซอย '+result[0].alley_university});
                    this.setState(  {register_taxPROVINCE: result[0].province_university});
                    this.setState(  {register_taxAMPHUR: result[0].district_university});
                    this.setState(  {register_taxDISTRICT: result[0].subdistrict_university});
                    this.setState(  {register_taxCODE: result[0].TaxID_university});
              
             }else{
                    this.setState({register_university: ''}); 
                    this.setState({register_nameuniversity: ''}); 
                    this.setState({register_numhome: ''	}); 
                    this.setState({register_moo: '' }); 
                    this.setState({register_street: '' }); 
                    this.setState({register_soi: '' }); 
                    this.setState({register_private: '' }); 
                    this.setState({register_ditric: '' }); 
                    this.setState({register_subdritic: '' }); 
                    this.setState({register_zipcode:'' }); 
                    this.setState({register_taxnumber: '' }); 
                  //ภาษี
                    this.setState(  {register_taxadress: '' });
                    this.setState(  {register_taxPROVINCE: '' });
                    this.setState(  {register_taxAMPHUR: '' });
                    this.setState(  {register_taxDISTRICT: '' });
                    this.setState(  {register_taxCODE: '' });
                    

             }
            
             }


          handleChangeuniversity(event) { 
            this.setState({register_university: event.target.value}); 
            if (event.target.value === '999') {
              this.setState({showadduniversityother: '1'}); 
              this.setState({register_nameuniversity: ''}); 
              this.setState({register_numhome: ''	}); 
              this.setState({register_moo: ''}); 
              this.setState({register_street: ''}); 
              this.setState({register_soi: ''}); 
              this.setState({register_private: ''}); 
              this.setState({register_ditric: ''}); 
              this.setState({register_subdritic: ''}); 
              this.setState({register_zipcode: ''}); 
             

               
            } else {
              this.setState({showadduniversityother: ''}); 
              // this.setState({register_university: event.target.value}); 
                const result =  this.state.universityaddress.filter((word) => word.id_university	 === event.target.value);
                console.log(result[0].road_university)
                this.setState({register_nameuniversity: result[0].name_university}); 
                this.setState({register_numhome: result[0].homenum_university	}); 
                this.setState({register_moo: result[0].moo_university}); 
                this.setState({register_street: result[0].road_university}); 
                this.setState({register_soi: result[0].alley_university}); 
                this.setState({register_private: result[0].province_university}); 
                this.setState({register_ditric: result[0].district_university}); 
                this.setState({register_subdritic: result[0].subdistrict_university}); 
                this.setState({register_zipcode: result[0].zipcode_university}); 
                this.setState({register_taxnumber: result[0].TaxID_university}); 
              //ภาษี
                this.setState(  {register_taxadress: result[0].homenum_university+' หมู่ '+result[0].moo_university+' ถนน '+result[0].road_university+' ซอย '+result[0].alley_university});
                this.setState(  {register_taxPROVINCE: result[0].province_university});
                this.setState(  {register_taxAMPHUR: result[0].district_university});
                this.setState(  {register_taxDISTRICT: result[0].subdistrict_university});
                this.setState(  {register_taxCODE: result[0].TaxID_university});
            }

               

               
               }
          handleChangetypepay(event) {  
              this.setState(  {register_typepay: event.target.value});
              if (event.target.value === '1') {
                this.setState(  {register_taxadress: this.state.register_numhome+' หมู่ '+this.state.register_moo+' ถนน '+this.state.register_street+' ซอย '+this.state.register_soi});
                this.setState(  {register_taxPROVINCE: this.state.provincename});
                this.setState(  {register_taxAMPHUR: this.state.ampername});
                this.setState(  {register_taxDISTRICT: this.state.districtname});
                this.setState(  {register_taxCODE: this.state.register_zipcode});
              }
          }
          handleChangetgender(event) {    this.setState({register_sex: event.target.value});  }
          handleChange2(event) {    this.setState({Psaaword: event.target.value});  }

          handleSubmit= (e) => {
            e.preventDefault();
            // alert('A name was submitted: ' + this.state.value);
            const date = new Date();
            const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
            const dates = day+"-"+month+"-"+year ;
            
            this.setState(  {loading: true});

                  setTimeout(() => {

                      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                      datafrm.append("register_typemamberinout", this.state.register_typemamberinout);//เพิ่มเติม
                      datafrm.append("register_typemamber", this.state.register_typemamber);
                      datafrm.append("register_email", this.state.register_email);
                      datafrm.append("register_username", this.state.register_email);
                      datafrm.append("register_pass", this.state.register_pass);
                      datafrm.append("register_oldpass", this.state.register_pass2);
                      datafrm.append("register_nameth", this.state.register_nameth);
                      datafrm.append("register_lnameth", this.state.register_lnameth);
                      datafrm.append("register_pname", this.state.register_pname);
                      datafrm.append("register_nameen", this.state.register_nameen);
                      datafrm.append("register_lnameen", this.state.register_lnameen);
                      datafrm.append("register_sex", this.state.register_sex);
                      datafrm.append("register_university", this.state.register_university);//เพิ่มเติม
                      datafrm.append("register_nameuniversity", this.state.register_nameuniversity);//เพิ่มเติม
                      datafrm.append("register_faculty", this.state.register_faculty);//เพิ่มเติม
                      datafrm.append("register_program", this.state.register_program);//เพิ่มเติม
                      datafrm.append("register_numhome", this.state.register_numhome);
                      datafrm.append("register_moo", this.state.register_moo);
                      datafrm.append("register_street", this.state.register_street);
                      datafrm.append("register_soi", this.state.register_soi);
                      datafrm.append("register_private", this.state.register_private);
                      datafrm.append("register_ditric", this.state.register_ditric);
                      datafrm.append("register_subdritic", this.state.register_ditric);
                      datafrm.append("register_zipcode", this.state.register_zipcode);
                      datafrm.append("register_phone", this.state.register_phone);
                      datafrm.append("register_date", dates);
                      datafrm.append("register_activate", this.state.register_activate);
                      datafrm.append("register_status", this.state.register_status);

                      datafrm.append("register_typepay", this.state.register_typepay);
                      datafrm.append("register_taxnumber", this.state.register_taxnumber);
                      datafrm.append("register_taxadress", this.state.register_taxadress);
                      datafrm.append("register_taxDISTRICT", this.state.register_taxDISTRICT);
                      datafrm.append("register_taxAMPHUR", this.state.register_taxAMPHUR);
                      datafrm.append("register_taxPROVINCE", this.state.register_taxPROVINCE);
                      datafrm.append("register_taxCODE", this.state.register_zipcode);
                      datafrm.append("register_OLDID", this.state.OLDID);

                      api.post("registercon/Insertregistercon",datafrm,{
                //  Axios.post("https://conference.kpru.ac.th/PHPAPI/uploadcomment1show.php",datafrm,{
                    headers: {
                        'content-type': 'multipart/form-data'
                      }
                    })
                
                   .then(res => {
                          console.warn(res);
                          console.log("response: ", res)
                          if (res.data.length !== 0) {
                            console.log(res)
                            console.log(res.data.length) 
                          }else{
                         
                          }
                
                    if (res.data === '200') {


                                    api.get('registercon/selectuserlater/'+this.state.register_typemamberinout+'/'+this.state.register_typemamber+'/'+this.state.register_email+'/'+this.state.register_university+'/'+this.state.register_pass)
                                    .then(res => {
                                      //  console.log(res);
                                      //  this.setState({ bankname: res.data, loading: false })
                                      //  this.setState({ registertype: res.data})
                                      // const result =  res.data.filter((word) => word.network	 === '1');
                                      // this.setState({ registertype: result})
                                      // const resultout =  res.data.filter((word) => word.network	 != '1');
                                      // this.setState({ registertypeout: resultout})
                                        if (res.data.length > 0) {
                                                const id_registers =  res.data[0].id_register
                                                setTimeout(() => {

                                                  const date = new Date();
                                                  const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
                                                  const dates = day+"-"+month+"-"+year ;
                                              
                                                    const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                                                    datafrm.append("send_id", id_registers);
                                                    datafrm.append("pnamelisten", this.state.register_pname);
                                                    datafrm.append("namelisten", this.state.register_nameth);
                                                    datafrm.append("lnamelisten",  this.state.register_lnameth);
                                                    datafrm.append("agencylisten", this.state.register_nameuniversity);
                                                    datafrm.append("tellisten", this.state.register_phone);
                                                    datafrm.append("registerlisten_taxnumber", this.state.register_taxnumber);
                                                    datafrm.append("registerlisten_taxadress", this.state.register_taxadress);
                                                    datafrm.append("registerlisten_taxDISTRICT", this.state.register_taxDISTRICT);
                                                    datafrm.append("registerlisten_taxAMPHUR", this.state.register_taxAMPHUR);
                                                    datafrm.append("registerlisten_taxPROVINCE", this.state.register_taxPROVINCE);
                                                    datafrm.append("registerlisten_taxCODE", this.state.register_zipcode);
                                                    datafrm.append("external_typelisten", this.state.register_typemamber);
                                              
                                                    datafrm.append("sendlisten_date", dates);
                                                
                                                  api.post("registercon/Insertlisten",datafrm,{
                                                  headers: {
                                                      'content-type': 'multipart/form-data'
                                                  }
                                                })
                                              
                                                .then(res => {
                                                  console.warn(res);
                                                  console.log("response: ", res)
                                                  if (res.data.length !== 0) {
                                                    // this.showitem = true;
                                                    console.log(res)
                                                    console.log(res.data.length) 
                                                  }else{
                                                  // window.location.href = '/'
                                                  }
                                              
                                              
                                                  if (res.data = '200') {
                                                  // message.success("อัพโหลไฟล์สำเร็จ")
                                                  //  this.setState({ id_send: ""})
                                                  // window.location.href = '/adminfaculty'
                                                  this.setState(  {loading: false});
                                                  Swal.fire({
                                                    title: 'ลงทะเบียนสำเร็จ',
                                                    text: "Successfully registered",
                                                    icon: 'success',
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#3085d6',
                                                    cancelButtonColor: '#d33',
                                                    confirmButtonText: 'ตกลง'
                                                  }).then((result) => {
                                                    if (result.isConfirmed) {
                                                       window.location.href = 'https://scitech.kpru.ac.th/csrm2025/system/'
                                                      // Swal.fire(
                                                      //   'Deleted!',
                                                      //   'Your file has been deleted.',
                                                      //   'success'
                                                      // )
                                                     // this.props.list();
                                                      //this.toggle()
                                                    }
                                                  })
                                                  
                                                  }else{
                                                    this.setState(  {loading: false});
                                                    message.error("อัพโหลไฟล์ไม่สำเร็จ!")
                                                  }
                                              
                                                })
                                              
                                              
                                              
                                              }, 2000);
                                        } else {
                                          
                                        }
                  
                                    }) 


                    
                          // Swal.fire({
                          //   title: 'ลงทะเบียนสำเร็จ',
                          //   text: "Successfully registered",
                          //   icon: 'success',
                          //   showCancelButton: false,
                          //   confirmButtonColor: '#3085d6',
                          //   cancelButtonColor: '#d33',
                          //   confirmButtonText: 'ตกลง'
                          // }).then((result) => {
                          //   if (result.isConfirmed) {
                          //       window.location.href = '/'
                          //   }
                          // })

                    }else{
                      message.error("ลงทะเบียนไม่สำเร็จ!")
                    }
                
                  })
                
                }, 1000);
     
          }

          componentDidMount() {
              setTimeout(() => {
                //จังหวัด
                 Axios.get('https://mua.kpru.ac.th/FrontEnd_creditbank/index/getprovince')
                .then(res => {
                //  console.log(res);
                //  this.setState({ bankname: res.data, loading: false })
                const data = res.data
                const options = data.map(d => ({
                    "value" : d.PROVINCE_ID,
                    "label" : d.PROVINCE_NAME_TH
                  }))
                  this.setState({ PROVINCE: options})
                }) 
              }, 0);
              

              setTimeout(() => {
           
                api.get('registercon/selectregistertype')
                 .then(res => {
                   console.log(res);
                 //  this.setState({ bankname: res.data, loading: false })
                 //  this.setState({ registertype: res.data})
                   const result =  res.data.filter((word) => word.network	 === '1');
                    this.setState({ registertype: result})
                    const resultout =  res.data.filter((word) => word.network	 != '1');
                    this.setState({ registertypeout: resultout})


                 }) 
               }, 0);

               setTimeout(() => {
           
                api.get('registercon/selectuniversityaddress')
                 .then(res => {
                   console.log(res);
                 //  this.setState({ bankname: res.data, loading: false })
                  const ss = res.data;
                 ss.push({id_university:'999',name_university:'มหาวิทยาลัยอื่น/หน่วยงานอื่น',homenum_university:'',moo_university:'',road_university:'',alley_university:'',subdistrict_university:'',district_university:'',province_university:'',zipcode_university:''});
                  this.setState({ universityaddress: ss})
                // console.log(ss);
                 }) 
               }, 0);

               this.getprefix();


               setTimeout(() => {
               
                api.get('registercon/selectdateopen')
                 .then(res => {
                   console.log(res);
                   //  this.setState({ bankname: res.data, loading: false })
                   // this.setState({ dateopen: res.data})
                   const result =  res.data.filter((word) => word.type_dateopen	 === "ลงทะเบียน");
                   //   console.log(result[0].start_dateopen);
                   //   console.log(result[0].close_dateopen);
                   const event = result[0].start_dateopen;
                   const event2 = result[0].close_dateopen;
  
                   const date = new Date();
                   const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
                   const dates = day+"-"+month+"-"+year ;
             
                   const dateFrom = event;
                   const dateTo = event2;
                   // const dateTo = "10-11-2024";
                   const dateCheck = dates;
             
                   const d1 = dateFrom.split("-");
                   const d2 = dateTo.split("-");
                   const c = dateCheck.split("-");
             
                   const from = new Date(d1[2], parseInt(d1[1])-1, d1[0]);  // -1 because months are from 0 to 11
                   const to   = new Date(d2[2], parseInt(d2[1])-1, d2[0]);
                   const check = new Date(c[2], parseInt(c[1])-1, c[0]);
                   const checkshow = check >= from && check <= to;
  
                  this.setState({ opensystem: checkshow})
  
  
                 }) 
               }, 0);




          }

             //จังหวัดข้อมูลส่วนตัว
           handleprovince(e,u){
          // console.log(u)
           this.setState({province:u.value, provincename:u.label})
           setTimeout(() => {
               //จังหวัด
                Axios.get('https://mua.kpru.ac.th/FrontEnd_creditbank/index/getdistrict/'+u.value)
               // Axios.get('http://localhost/phpapi/selectamphures.php?PROVINCE_ID='+u.value)
               .then(res => {
             //    console.log(res);
               //  this.setState({ bankname: res.data, loading: false })
               const data = res.data
               const optionsam = data.map(a => ({
                   "value" : a.DISTRICT_ID,
                   "label" : a.DISTRICT_NAME_TH
                 }))
                 this.setState({ AMPHUR: optionsam})
               }) 
             }, 0);
          }

          //อำเภอข้อมูลส่วนตัว
          handleamphur(e,u){
           // console.log(u)
            this.setState({amper:u.value, ampername:u.label})
            setTimeout(() => {
                //จังหวัด
                 Axios.get('https://mua.kpru.ac.th/FrontEnd_creditbank/index/getsubdistrict/'+u.value)
               //  Axios.get('http://localhost/phpapi/selectdistricts.php?AMPHUR_ID='+u.value)
                .then(res => {
                 // console.log(res);
                //  this.setState({ bankname: res.data, loading: false })
                const data = res.data
                const optionsds = data.map(a => ({
                    "value" : a.SUB_DISTRICT_ID,
                    "label" : a.SUB_DISTRICT_NAME_TH
                  }))
                  this.setState({ DISTRICT: optionsds})
                }) 
              }, 0);

              // Axios.get('https://conference.kpru.ac.th/phpapi/selectzipcode.php?AMPHUR_ID='+u.value)
              // //  Axios.get('http://localhost/phpapi/selectdistricts.php?AMPHUR_ID='+u.value)
              //  .then(res => {
              //    console.log(res.data[0].POST_CODE);
              //  //  this.setState({ bankname: res.data, loading: false })
              //  const data = res.data
              // //  const optionsds = data.map(a => ({
              // //      "value" : a.DISTRICT_CODE,
              // //      "label" : a.DISTRICT_NAME
              // //    }))
              //     this.setState({ register_zipcode: res.data[0].POST_CODE})
              //  }) 
          }

            //ตำบลข้อมูลส่วนตัว
            handledistrict(e,u){
           // console.log(u)
            this.setState({district:u.value, districtname:u.label})

            // setTimeout(() => {
               
            //     //จังหวัด
            //      Axios.get('https://thenextth.com/registerfa/selectzipcode.php?DISTRICT_CODE='+u.value)
            //     // Axios.get('http://localhost/phpapi/selectzipcode.php?DISTRICT_CODE='+u.value)
            //     .then(res => {
            //   //    console.log(res);
            //     //  this.setState({ bankname: res.data, loading: false })
            //     //const data = res.data[0].zipcode
            //    //  const optionsds = data.map(a => ({
            //    //      "value" : a.DISTRICT_ID,
            //    //      "label" : a.DISTRICT_NAME
            //    //    }))
            //       this.setState({ zipcode: res.data[0].zipcode})
            //     }) 
            //   }, 0);
           }



    render() {

      const items = this.state.registertype.map((registertype, i) => (
        <option  value={registertype.id_typeregister} >{registertype.name_typeregister}</option>
      ));
      const itemsout = this.state.registertypeout.map((registertype, i) => (
        <option  value={registertype.id_typeregister} >{registertype.name_typeregister}</option>
      ));
       const itemsuniversity= this.state.universityaddress.map((universityaddress, i) => (
        <option  value={universityaddress.id_university} >{universityaddress.name_university}</option>
      ));

     

      console.log(this.state.register_typemamber)
      console.log(this.state.register_typepay)
      // console.log(this.state.amper)
      // console.log(this.state.registertypeout)
      // console.log(this.state.registertype)

        return (
          <MDBContainer className="mt-1 ">
                <div className='mt-1'>
                 <img src={ban} className="rounded  d-block "alt="aligment" />
              </div>
         
              <MDBJumbotron >
{this.state.opensystem === true?<>
  



                <div className='text-center'>
                <h2 className="font-weight-bold">ลงทะเบียน</h2>
                <p className="lead font-weight-bold">
                การประชุมวิชาการและนำเสนอผลงานด้านคณิตศาสตร์ ครั้งที่ 12
                </p>
                </div>
                <hr className="my-2" />


                <form 
                onSubmit={this.handleSubmit}
                 >
                           <h4>ข้อมูลผู้ลงทะเบียน</h4>

                              <div className="mb-2">
                             <label rules={[{ required: true }]} className="font-weight-bold">  ประเภทบุคลากร</label> <label className="red-text">*</label><br/>
                            
                                <Radio.Group onChange={this.handleChangetypeinout} required={true}  >
                                  <Radio value="1">บุคลากรภายใน </Radio>
                                  <Radio value="2">บุคลากรภายนอก </Radio>
                                </Radio.Group>
                            </div> 

                            <div className="mb-2">
                            <label className="font-weight-bold"><strong>ประเภทผู้ลงทะเบียน</strong></label>
                              {this.state.register_typemamberinout === '1'?<>
                              <select className="browser-default custom-select" onChange={this.handleChangetype} value={this.state.register_typemamber} required>
                                                            <option value="" >---เลือกประเภทผู้ลงทะเบียน---</option>
                                                            {items}
                                                          </select>
                              </>:<>
                              {this.state.register_typemamberinout === '2'?<>
                                  <select className="browser-default custom-select" onChange={this.handleChangetype} value={this.state.register_typemamber} required>
                                                            <option value="" >---เลือกประเภทผู้ลงทะเบียน---</option>
                                                            {itemsout}
                                                          </select>
                              </>:<> <select className="browser-default custom-select"  required>
                                                            <option value="" >---เลือกประเภทผู้ลงทะเบียน---</option>
                                                          
                                                          </select></>}
                          
                              </>}
                           


                            </div>

                            {this.state.studentmath === true ?<>
                              <div className="mb-2">
                              <label className="font-weight-bold">รหัสนักศึกษา (เพื่อตรวจสอบสิทธิ์)</label><label className="red-text">*</label>
                              <input  className="form-control" onChange={this.handleChange} name="OLDID"  placeholder="กรุณาระบุ รหัสนักศึกษาเพื่อตรวจสอบสิทธิ์" required/>
                             {this.state.studentmathstatus === true?<><p className="teal-text">ตรวจสอบสิทธิ์ผ่าน</p></>:<><MDBBtn color="primary" size='sm' onClick={this.getcheck} >ตรวจสอบสิทธิ์</MDBBtn> </>} 
                              {/* <MDBInputGroup
                                    material
                                    containerClassName="mb-3 mt-0"
                                    prepend={
                                      <MDBBtn className="m-0 px-3 py-2 z-depth-0">
                                        BUTTON
                                      </MDBBtn>
                                    }
                                  /> */}
                            </div>
                            </>:<></>}



                            <div className="mb-2">
                              {this.state.register_typemamber ==='1'?<> <label>e-mail ของมหาวิทยาลัย</label><label className="red-text">*</label></>:<>
                               <label className="font-weight-bold">e-mail</label><label className="red-text">*</label>
                              </>}
                                <input  className="form-control" onChange={this.handleChange} name="register_email" 
                                    value={this.state.register_email} placeholder="กรุณาระบุ e-mail" required />
                            </div>

                            <div className="mb-2">
                                <label className="font-weight-bold">รหัสผ่าน (ความยาว 6 ตัวอักษรขึ้นไป)</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_pass"
                                    value={this.state.register_pass} placeholder="กรุณาระบุ รหัสผ่าน" required />
                            </div>
                            <div className="mb-2">
                                <label className="font-weight-bold">ยืนยันรหัสผ่าน (ความยาว 6 ตัวอักษรขึ้นไป)</label><label className="red-text">* </label> 
                                {this.state.register_pass2 !== ''?<>
                                 {this.state.register_pass !== this.state.register_pass2 ?<><label className="red-text">รหัสผ่านไม่ตรงกัน </label></>:<></>}
                                </>:<></>}
                               
                                <input  className="form-control" onChange={this.handleChange} name="register_pass2"
                                    value={this.state.register_pass2} placeholder="กรุณาระบุ ยืนยันรหัสผ่าน" required />
                            </div>
                            <div className="mb-2">
                                <label className="font-weight-bold">คำนำหน้า</label><label className="red-text">*</label>
                                 {/* <input  className="form-control" onChange={this.handleChange} name="register_pname"
                                    value={this.state.register_pname} placeholder="กรุณาระบุ คำนำหน้า" required /> */}
                                         <Select
                                          className="form-control"
                                          onChange={this.handleChangeprefix}
                                          showSearch
                                          style={{ width: '100%' }}
                                          placeholder="กรุณาระบุ คำนำหน้า"
                                          optionFilterProp="label"
                                          name="register_pname"
                                          filterSort={(optionA, optionB) =>
                                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                          }
                                          options={this.state.getprefix}
                                          required
                                        />
                            </div>

                            <MDBRow>
                              <MDBCol lg="6">
                                <div className="mb-2">
                                <label className="font-weight-bold">ชื่อ (ภาษาไทย) </label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_nameth"
                                    value={this.state.register_nameth} placeholder="กรุณาระบุ ชื่อ (ภาษาไทย)" required />
                                </div>
                            </MDBCol>
                              <MDBCol lg="6">
                              <div className="mb-2">
                                <label className="font-weight-bold">นามสกุล (ภาษาไทย) </label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_lnameth"
                                    value={this.state.register_lnameth} placeholder="กรุณาระบุ นามสกุล (ภาษาไทย)" required />
                                </div>
                              </MDBCol>
                            </MDBRow>

                            <MDBRow>
                              <MDBCol lg="6">
                              <div className="mb-2">
                                <label className="font-weight-bold">ชื่อ (ภาษาอังกฤษ)</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_nameen"
                                    value={this.state.register_nameen} placeholder="กรุณาระบุ ชื่อ (ภาษาอังกฤษ)" required />
                              </div>
                              </MDBCol>
                              <MDBCol lg="6">
                              <div className="mb-2">
                                <label className="font-weight-bold">นามสกุล (ภาษาอังกฤษ)</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_lnameen"
                                    value={this.state.register_lnameen} placeholder="กรุณาระบุ นามสกุล (ภาษาอังกฤษ)" required />
                            </div>
                                </MDBCol>
                            </MDBRow>

                            
                           
                          <div className="mb-2">
                                <label rules={[{ required: true }]} className="font-weight-bold">เพศ</label><label className="red-text">*</label><br/>
                            
                                <Radio.Group onChange={this.handleChangetgender} required={true} >
                                <Radio value="1">ชาย</Radio>
                                <Radio value="2">หญิง</Radio>
                               
                                </Radio.Group>
                            </div>


                            {this.state.register_typemamberinout === '1'?<>
                                  <div className="mb-2">
                                    <label className="font-weight-bold">มหาวิทยาลัย</label><label className="red-text">*</label>
                                    <input  className="form-control" 
                                        value={this.state.register_nameuniversity} placeholder="กรุณาระบุ ชื่อมหาวิทยาลัย/หน่วยงานอื่น" disabled  />
                                  </div>
                            </>:<>
                                  <div className="mb-2">
                                  <label className="font-weight-bold">มหาวิทยาลัย</label><label className="red-text">*</label>
                                  <select className="browser-default custom-select" onChange={this.handleChangeuniversity} neme="register_university" value={this.state.register_university} required>
                                    <option value=""  >---เลือกมหาวิทยาลัย---</option>
                                    {itemsuniversity}
                                  </select>
                                  </div>
                            </>}

                            

                            {this.state.showadduniversityother === '1'?<>
                              <div className="mb-2">
                                <label className="font-weight-bold">ชื่อมหาวิทยาลัย/หน่วยงานอื่น</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_nameuniversity"
                                    value={this.state.register_nameuniversity} placeholder="กรุณาระบุ ชื่อมหาวิทยาลัย/หน่วยงานอื่น" required />
                            </div>
                            </>:<></>}

                            {this.state.showfaculty === true?<>
                              <div className="mb-2">
                              <label className="font-weight-bold">คณะ</label><label className="red-text">*</label>
                               <select className="browser-default custom-select" onChange={this.handleChange}  value={this.state.register_faculty} name="register_faculty" required>
                                                                          <option>------กรุณาเลือกคณะ------</option>
                                                                          <option value="คณะวิทยาศาสตร์และเทคโนโลยี" >คณะวิทยาศาสตร์และเทคโนโลยี</option>
                                                                          <option value="คณะครุศาสตร์" >คณะครุศาสตร์</option>
                                                                       
                                 </select>
                              </div>                                
                            </>:<>
                            <div className="mb-2">
                                <label className="font-weight-bold">คณะ</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_faculty"
                                    value={this.state.register_faculty} placeholder="กรุณาระบุ คณะ" required />
                            </div>
                            </>}
                            

                            <div className="mb-2">
                                <label className="font-weight-bold">สาขา/โปรแกรมวิชา/ภาควิชา</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_program"
                                    value={this.state.register_program} placeholder="กรุณาระบุ สาขา/โปรแกรมวิชา/ภาควิชา" required />
                            </div>

                            <div className="mb-2">
                                <label className="font-weight-bold">เลขที่</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_numhome"
                                    value={this.state.register_numhome} placeholder="กรุณาระบุ เลขที่" required />
                            </div>

                            <div className="mb-2">
                                <label className="font-weight-bold">หมู่</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_moo"
                                    value={this.state.register_moo} placeholder="กรุณาระบุ หมู่" required />
                            </div>

                            <div className="mb-2">
                                <label className="font-weight-bold">ถนน</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_street"
                                    value={this.state.register_street} placeholder="กรุณาระบุ ถนน" required />
                            </div>

                            <div className="mb-2">
                                <label className="font-weight-bold">ซอย</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_soi"
                                    value={this.state.register_soi} placeholder="กรุณาระบุ ซอย" required />
                            </div>

                            <div className="mb-2">
                                <label className="font-weight-bold">จังหวัด</label><label className="red-text">*</label>
                                {/* <Select placeholder="กรุณาระบุ จังหวัด"  className="browser-default custom-select " options={this.state.PROVINCE}  onChange={this.handleprovince.bind(this)} required/><br/> */}
                                <input  className="form-control" onChange={this.handleChange} name="register_private"
                                    value={this.state.register_private} placeholder="กรุณาระบุ จังหวัด" required />
                            </div>

                            <div className="mb-2">
                                <label className="font-weight-bold">อำเภอ</label><label className="red-text">*</label>
                                {/* <Select placeholder="กรุณาระบุ อำเภอ"  className="bbrowser-default custom-select " options={this.state.AMPHUR}  onChange={this.handleamphur.bind(this)} required/> */}
                                <input  className="form-control" onChange={this.handleChange} name="register_ditric"
                                    value={this.state.register_ditric} placeholder="กรุณาระบุ อำเภอ" required />
                            </div>

                            <div className="mb-2">
                                <label className="font-weight-bold">ตำบล</label><label className="red-text">*</label>
                                {/* <Select placeholder="กรุณาระบุ ตำบล"  className="bbrowser-default custom-select " options={this.state.DISTRICT}  onChange={this.handledistrict.bind(this)} required/> */}
                                <input  className="form-control" onChange={this.handleChange} name="register_subdritic"
                                    value={this.state.register_subdritic} placeholder="กรุณาระบุ ตำบล" required />
                            </div>

                            <div className="mb-2">
                                <label className="font-weight-bold">รหัสไปษณีย์</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_zipcode"
                                value={this.state.register_zipcode} placeholder="กรุณาระบุ รหัสไปษณีย์" required />
                            </div>






                            {/* <div className="mb-2">
                                <label>จังหวัด</label><label className="red-text">*</label>
                                <Select placeholder="กรุณาระบุ จังหวัด"  className="browser-default custom-select " options={this.state.PROVINCE}  onChange={this.handleprovince.bind(this)} required/><br/>
                            </div>

                            <div className="mb-2">
                                <label>อำเภอ</label><label className="red-text">*</label>
                                <Select placeholder="กรุณาระบุ อำเภอ"  className="bbrowser-default custom-select " options={this.state.AMPHUR}  onChange={this.handleamphur.bind(this)} required/>
                            </div>

                            <div className="mb-2">
                                <label>ตำบล</label><label className="red-text">*</label>
                                <Select placeholder="กรุณาระบุ ตำบล"  className="bbrowser-default custom-select " options={this.state.DISTRICT}  onChange={this.handledistrict.bind(this)} required/>
                            </div>

                            <div className="mb-2">
                                <label>รหัสไปษณีย์</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_zipcode"
                                value={this.state.register_zipcode} placeholder="กรุณาระบุ รหัสไปษณีย์" required />
                            </div> */}

                            <div className="mb-2">
                                <label className="font-weight-bold">เบอร์โทร</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_phone"
                                    value={this.state.register_phone} placeholder="กรุณาระบุ เบอร์โทร" required />
                            </div><br/>

                  {( this.state.register_typemamber ==='8' || this.state.register_typemamber ==='7') && this.state.register_university === '999' ?<>
                  <h4>ข้อมูลการออกใบเสร็จ</h4>

                            <br/>
                            {this.state.register_typepay ==='1'?<>
                              <div className="mb-2">
                                <label className="font-weight-bold">เลขที่ผู้เสียภาษีบุคคลทั่วไป </label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_taxnumber" max={13} min={13}
                                    value={this.state.register_taxnumber} placeholder="กรุณาระบุ เลขที่ผู้เสียภาษีบุคคลทั่วไป" required />
                              </div>

                              <div className="mb-2">
                                <label className="font-weight-bold">ที่อยู่</label><label className="red-text">*</label>
                                <input   className="form-control" onChange={this.handleChange} name="register_taxadress"
                                    value={this.state.register_taxadress} placeholder="กรุณาระบุ ที่อยู่ที่" required  />
                              </div>

                              <div className="mb-2">
                                <label className="font-weight-bold">ตำบล</label><label className="red-text">*</label>
                                <input   className="form-control" onChange={this.handleChange} name="register_taxDISTRICT"
                                    value={this.state.register_taxDISTRICT} placeholder="กรุณาระบุ ตำบล" required  />
                              </div>
                              
                              <div className="mb-2">
                                <label className="font-weight-bold">อำเภอ</label><label className="red-text">*</label>
                                <input   className="form-control" onChange={this.handleChange} name="register_taxAMPHUR"
                                    value={this.state.register_taxAMPHUR} placeholder="กรุณาระบุ อำเภอ" required  />
                              </div>
                              
                              <div className="mb-2">
                                <label className="font-weight-bold">จังหวัด</label><label className="red-text">*</label>
                                <input   className="form-control" onChange={this.handleChange} name="register_taxPROVINCE"
                                    value={this.state.register_taxPROVINCE} placeholder="กรุณาระบุ จังหวัด" required  />
                              </div>

                              <div className="mb-2">
                                <label className="font-weight-bold">รหัสไปรษณีย์</label><label className="red-text">*</label>
                                <input   className="form-control" onChange={this.handleChange} name="register_taxCODE"
                                    value={this.state.register_taxCODE} placeholder="กรุณาระบุ รหัสไปรษณีย์" required  />
                              </div>
                             <p className="red-text">ตรวจสอบความถูกต้อง เลขที่ผู้เสียภาษีของหน่วยงาน และที่อยู่ที่จะแสดงในใบเสร็จให้ถูกต้อง</p>
                             <p className="red-text">ใบเสร็จจะออกในรูปแบบอิเล็กทรอนิกส์</p>
                             
                            </>:<></>}
</>:<></>}

                            


                <div className='text-center'>

             {this.state.register_typemamber === '1' ?<>

                  {this.state.register_typemamber === '1' && this.state.studentmathstatus === true ?<>
                    {this.state.loading === true ?<>
                     <Button type="primary" loading>
                    Loading
                  </Button>
                    </>:<> <MDBBtn color="primary" type='submit'  >ลงทะเบียน</MDBBtn> </>}
                   

                   
                  </>:<>
                  <MDBBtn color="primary" type='submit' disabled >ท่านไม่มีสิทธิ์ลงทะเบียนประเภทนักศึกษาสาขาคณิตศาสตร์ กรุณาตรวจสอบสิทธิ์</MDBBtn> 
                  </>}

             </>:<>
               {this.state.register_pass !== this.state.register_pass2 ?<><label className="red-text"><p>รหัสผ่านไม่ตรงกัน</p> <MDBBtn color="primary" type='submit' disabled >ลงทะเบียน</MDBBtn> </label></>:<> 
             {this.state.loading === true?<>
              <Button type="primary" loading>
          Loading
        </Button>
             </>:<>
             <MDBBtn color="primary" type='submit' >ลงทะเบียน</MDBBtn>
             </>}  
              
                </>}
             </>}
                               
                             
                  {/* <MDBBtn color="primary" type='submit' >ลงทะเบียน</MDBBtn>  */}
                  </div>
                  
                </form>

                 {/* <MDBBtn color="primary" onClick={this.handleSubmitd} >ลงทะเบียน</MDBBtn>  */}




                 </>:<>
               
                <h3 className='text-center'>ระบบปิดรับลงทะเบียนแล้ว</h3>
                <Result
                    status="403"
                    title="Sorry"
                    subTitle="Sorry, you are not authorized to access this page."
                    //extra={<Button type="primary">Back Home</Button>}
                  />
               
                </>}
              </MDBJumbotron>
         
        </MDBContainer>
        )
    }
}
